module.exports = __webpack_public_path__ + "img/21_91.b99316d1.png";